export const RF_FOR_SLICING_REQUEST = "RF_FOR_SLICING_REQUEST";
export const RF_FOR_SLICING_SUCCESS = "RF_FOR_SLICING_SUCCESS";
export const RF_FOR_SLICING_FAILED = "RF_FOR_SLICING_FAILED";
